import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"mb-5\"><div class=\"row\"><div class=\"col-12 col-lg-6 col-md-6 col-sm-12\"><h2 class=\"title\">Startup Guide Manager</h2><p class=\"mb-0 sub-title\"><small>Manage the application startup guides</small></p></div></div></div>", 1)
const _hoisted_3 = { class: "nav nav-tabs" }
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex flex-column gap-5"
}
const _hoisted_7 = { class: "w-100 bg-white p-5" }
const _hoisted_8 = { class: "font-weight-bold" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "fa fa-edit text-primary",
  style: {}
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  class: "fa fa-trash text-primary",
  style: {}
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navigator = _resolveComponent("Navigator")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!
  const _component_AddGuideModal = _resolveComponent("AddGuideModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navigator, {
      to: "/settings",
      text: "Back to settings"
    }),
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", _hoisted_4, [
        _createElementVNode("a", {
          class: _normalizeClass(["nav-link", { active: _ctx.tab == 'agent'}]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tab = 'agent')),
          "aria-current": "page",
          href: "javascript:void()"
        }, "Agent App", 2)
      ]),
      _createElementVNode("li", _hoisted_5, [
        _createElementVNode("a", {
          class: _normalizeClass(["nav-link", { active: _ctx.tab == 'tenant'}]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tab = 'tenant')),
          "aria-current": "page",
          href: "javascript:void()"
        }, "Tenant App", 2)
      ])
    ]),
    _createVNode(_component_Card, { "with-header": false }, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_skeleton, {
                  animated: "",
                  row: "5"
                })
              ])
            ]))
          : (_openBlock(), _createBlock(_component_DataTable, {
              key: 1,
              "table-data": _ctx.tableItems,
              "table-header": _ctx.tableHeaders,
              "row-class": "table-hover"
            }, {
              "cell-code": _withCtx(({ row: item }) => [
                _createElementVNode("strong", _hoisted_8, _toDisplayString(item.code), 1)
              ]),
              "cell-title": _withCtx(({ row: item }) => [
                _createTextVNode(_toDisplayString(item.title), 1)
              ]),
              "cell-subtitle": _withCtx(({ row: item }) => [
                _createTextVNode(_toDisplayString(item.subtitle), 1)
              ]),
              "cell-icon": _withCtx(({ row: item }) => [
                _createElementVNode("i", {
                  class: _normalizeClass(item.icon)
                }, null, 2)
              ]),
              "cell-action": _withCtx(({ row: item }) => [
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.editCard(item)),
                  class: "btn btn-icon"
                }, _hoisted_11, 8, _hoisted_9),
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.confirmDelete(item)),
                  class: "btn btn-icon"
                }, _hoisted_14, 8, _hoisted_12)
              ]),
              _: 1
            }, 8, ["table-data", "table-header"]))
      ]),
      _: 1
    }),
    _createVNode(_component_AddGuideModal, {
      "initial-values": _ctx.startupCard,
      type: _ctx.formType,
      modelValue: _ctx.add_startup_card,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.add_startup_card) = $event)),
      onOnUpdate: _ctx.handleUpdateStartupGuide,
      onOnSaved: _ctx.handleStoreStartupGuide,
      loading: _ctx.saving,
      appType: _ctx.tab
    }, null, 8, ["initial-values", "type", "modelValue", "onOnUpdate", "onOnSaved", "loading", "appType"])
  ]))
}